module.exports = __webpack_public_path__ + "img/pd-img17.6e066c54.png";